//import packages from node modules
import React, { useCallback, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { reduxForm, getFormValues } from 'redux-form'

//import utilities shared functions
import {
  checkStepHeight,
  LOCALE_STRING_OPTIONS,
  LOCALE_LANG_OPTIONS
} from '../../../../utilities/function/common'

import {
  getDataFromURL,
  getCID,
  getCurrentStep
} from '../../../../utilities/function/urlparams'

import {
  getAttributes
} from '../../../../utilities/function/configuration'

import {
  getCycle,
  getPriceByBillingCycleID
} from '../../../../utilities/function/billingCycle'

import {addItemToCart, editProductPage} from '../../../../app/action'

//import shared components
import Checkbox from '../../form/checkbox'
import SolidButton from '../../button/solidbutton'

//Form for Main Default Exported Component
let SelectAdditionalOptionsForm = (props) => {
  const { handleSubmit, data, location, showOn } = props
  const formRef = useRef(null)
  const { search } = location
  const URLparams = getDataFromURL(search)
  const { pid, uuid, a } = URLparams
  const cid = pid ? pid : uuid
  const { configurations, step } = useSelector(state => {
    const configurations = state.app.configurations
    const viewport = state.app.viewport
    let step = 2
    if (configurations && configurations[cid] && configurations[cid].step) {
      step = configurations[cid].step
    }
    return {
      configurations,
      step,
      viewport
    }
  })
  const generateOptions = useCallback(() => {
    if (data && data.length && configurations && configurations[cid]) {
      const productConfig = configurations[cid]
      if (productConfig) {
        const { billing_cycle_id, addons } = productConfig
        if (billing_cycle_id) {
          const getSelectedAddonValue = (item) => {
            const { id } = item
            if (addons && addons.length > 0) {
              return addons.find(item => {
                return item.id === id
              })
            }
            return null
          }
          return data.map((item) => {
            if (item && getAttributes(item)) {
              const { id } = item
              const { name, description, price,discount_price } = getAttributes(item)
              const billingCyclePrice = getPriceByBillingCycleID(price, billing_cycle_id)
              return ({
                label: name,
                description: description,
                price: billingCyclePrice ? parseFloat(billingCyclePrice.price).toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS) : '',
                cycle: billingCyclePrice ? getCycle(billingCyclePrice.name) : '',
                key: id,
                value: getSelectedAddonValue(item),
                initialValue: getSelectedAddonValue(item),
                discount: getPriceByBillingCycleID(discount_price, billing_cycle_id)
              })
            }
            return ({})
          })
        }
      }
    }
    return []
  }, [data, configurations, cid])
  const getShow = () => {
    let show = false
    const productConfig = configurations[cid]
    if (productConfig) {
      const getAddonStep = () => {
        let addonStep = 2
        if (productConfig && productConfig.breadcrumbs) {
          const { breadcrumbs } = productConfig
          const addonStepObj = breadcrumbs.find(item => item.label === 'Addons')
          if (addonStepObj && addonStepObj.itemStep) {
            addonStep = addonStepObj.itemStep
          }
        }
        return addonStep
      }
      if (getAddonStep() === productConfig.step) {
        let completed = true
        if (productConfig.breadcrumbs && productConfig.breadcrumbs.length > 0) {
          productConfig.breadcrumbs.forEach(item => {
            if (productConfig[item.configKey] === undefined && item.label !== 'Addons') {
              completed = false
            }
          })
        }
        if (completed) {
          show = true
        }
      }

    }
    return show
  }
  const renderButton = () => {
    if (getShow()) {
      const renderText = () => {
        if (a === 'edit') {
          return 'Update'
        } else {
          return 'Proceed to Cart'
        }
      }
      return <SolidButton type={'submit'}
                          className={'of-select-additional-options__button'}>{renderText()}</SolidButton>
    }
    return (<></>)
  }
  if (configurations) {
    const options = generateOptions()
    if (showOn === step || showOn === undefined) {
      return (
        <form ref={formRef} onSubmit={handleSubmit} className='of-select-additional-options__form'>
          <Checkbox className='of-select-additional-options__checkbox' name='addon' data={options}/>
          {renderButton()}
        </form>
      )
    }
  }
  return (<></>)
}

SelectAdditionalOptionsForm.propTypes = {
  handleSubmit: PropTypes.func,
  data: PropTypes.any,
  location: PropTypes.any,
  showOn: PropTypes.number,
  stepWrapperRef: PropTypes.object
}

SelectAdditionalOptionsForm = reduxForm({
  form: 'SelectAdditionalOptionsForm'
})(SelectAdditionalOptionsForm)

SelectAdditionalOptionsForm = withRouter(SelectAdditionalOptionsForm)


// Main Component
// Additional Options Upsell - Two Variants , eg: Wordpress Toolkit Upsell, Litespeed Checkboxes
let SelectAdditionalOptions = (props) => {
  const { data, callback, showOn, location, history } = props
  const {
    addons,
    configurations,
    cartData,
  } = useSelector(state => ({
    addons: getFormValues('SelectAdditionalOptionsForm')(state),
    configurations: state.app.configurations,
    cartData: state.app.cartData
  }))
  const dispatch = useDispatch()
  const stepWrapperRef = useRef(null)
  const cid = getCID(getDataFromURL(location.search))
  const step = getCurrentStep(configurations,cid)
  useEffect(() => {
    if (step === showOn || !showOn) {
      callback(addons)
      if(stepWrapperRef){
        checkStepHeight(stepWrapperRef)
      }
    }
  },[addons, callback,step, showOn,stepWrapperRef])
  const formOnSubmit = useCallback((values) => {
    callback(values)
    const { a, uuid } = getDataFromURL(location.search)
    const cid = getCID(getDataFromURL(location.search))
    const productConfig = configurations[cid]
    if (a === 'add') {
      addItemToCart(productConfig, dispatch, history, configurations, location)
    } else if (a === 'edit') {
      if (cartData) {
        editProductPage(uuid,configurations,cartData,dispatch,location,history)
      }else{
        history.push(`${history.location.pathname}`)
      }
    }
  }, [location, cartData, dispatch, history, callback, configurations])
  return (
    <div className={`of-select-additional-options of-step`} ref={stepWrapperRef}>
      <div className='of-step__wrapper'>
        <div className='of-select-additional-options__wrapper'>
          <div className='of-select-additional-options__heading text-font-1-100'>Additional Options</div>
          <SelectAdditionalOptionsForm data={data} onSubmit={formOnSubmit} showOn={showOn} />
        </div>
      </div>
    </div>
  )
}

SelectAdditionalOptions.propTypes = {
  data: PropTypes.any,
  callback: PropTypes.func,
  showOn: PropTypes.number,
  location: PropTypes.any,
  history: PropTypes.any
}

SelectAdditionalOptions = withRouter(SelectAdditionalOptions)

export default SelectAdditionalOptions
